import * as React from "react";

import { useHistory, useParams } from "react-router-dom";

import { IPageProps } from "../IPageProps";

import { Status, useHttpGet } from "Utility/useHttp";

import { IQuiltParams } from "Model/IQuiltParams";
import { RequestProgress } from "Components/RequestProgress";

interface IPropsFromRoute {
    readonly quiltCode: string;
}

export function QuiltCodePage(props: IPageProps): React.ReactElement {
    const history = useHistory();
    const params = useParams<IPropsFromRoute>();
    const request = useHttpGet<IQuiltParams>(`/api/resolve?code=${params.quiltCode}`);

    const setParams = props.setParams;

    React.useEffect(() => {
        if (request.status !== Status.Complete) {
            return;
        }

        setParams(request.data);

        // Don't redirect so we don't add an entry to the history.
        history.replace("/");
    },
    [request, history, setParams])

    return <RequestProgress request={request} errorMessage="Failed to resolve quilt code." />;
}